/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HomrState } from './homr.reducer';

export const selectHomrState = createFeatureSelector<HomrState>('homr');

export const selectHomrScheduleContent = createSelector(
  selectHomrState,
  (state) => state?.homrScheduleContent,
);

export const selectHomrGTGTContent = createSelector(
  selectHomrState,
  (state) => state?.homrGTGTContent,
);

export const selectHomrBanner = createSelector(selectHomrState, (state) => state?.homrBanner);

// Unused
export const selectHomrBundleContent = createSelector(
  selectHomrState,
  (state) => state?.homrBundleContent,
);

export const selectHomrContent = createSelector(selectHomrState, (state) => state?.homrContent);

export const selectHomrInStoreServices = createSelector(
  selectHomrState,
  (state) => state?.homrInStoreServices,
);

export const selectHomrRichContent = createSelector(
  selectHomrState,
  (state) => state?.homrRichContent,
);

// Derived selectors for common use cases
export const selectHomrEnhancedProductCard = createSelector(
  selectHomrRichContent,
  (richContent) => richContent?.enhancedProductCard ?? [],
);

// Unused
export const selectHomr3DImagery = createSelector(selectHomrRichContent, (richContent) => {
  if (richContent?.templateA?.pdp3DImagery) {
    return richContent.templateA.pdp3DImagery;
  }
  if (richContent?.templateB?.pdp3DImagery) {
    return richContent.templateB.pdp3DImagery;
  }
  return null;
});

// Unused
export const selectHomrProductStatsSlider = createSelector(
  selectHomrRichContent,
  (richContent) => richContent?.productStatsSlider ?? null,
);
